import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";
import { postRecoverPassword } from "features/public/registerClient";


interface UsuarioState {
    status: string;
    error: string;
    usuarioList: any[],
    resetData: { carnet: string; numeroTelefono: string; clave: string } | null;
    usuario: {
        idUsuario: number | null;
        idRol: number | null;
        rolNombre: string | null;
        user: string | null;
        carnet: string | null;
        clave: string | null;
        estado: number | null;
    }
}

const initialState: UsuarioState = {
    status: 'idle',
    error: '',
    usuarioList: [],
    resetData: null,
    usuario: {
        idUsuario: null,
        idRol: null,
        rolNombre: null,
        user: null,
        carnet: null,
        clave: null,
        estado: null,
    }
}

export const fetchUsuario = createAsyncThunk('fetchUsuario', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 29;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateUsuario = createAsyncThunk('modifyCreateUsuario', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectUsuario(state);
    const usuarioAttributes = { ...usuarioNew }
    const idsp = usuarioAttributes.idUsuario ? 6 : 5;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...usuarioAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchUsuario({}));
    return rejectWithValue(message);
});

export const updateEstadoUsuario = createAsyncThunk('updateEstadoUsuario', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectUsuario(state);
    const usuarioAttributes = { ...usuarioNew }
    const estado = !usuarioAttributes.estado;
    const idUsuario = usuarioAttributes.idUsuario;
    const idsp = 7;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idUsuario }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchUsuario({}));
    return rejectWithValue(message);
});

export const resetPassword = createAsyncThunk('resetPassword', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectUsuario(state);
    const idUsuario = usuarioNew.idUsuario;
    const clave = usuarioNew.clave || usuarioNew.carnet; // si viene clave personalizada se usa, sino el carnet (auto-genera en el SP)
    const idsp = 30;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, clave, idUsuario }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        dispatch(setDataToast(alert));
        dispatch(setVisibleToast(true));
        dispatch(setLoading(false));
        setTimeout(() => dispatch(setVisibleToast(false)), 4000);
        dispatch(fetchUsuario({}));
        try {
            const parsed = typeof data === 'string' ? JSON.parse(data) : data;
            return { resetData: parsed };
        } catch {
            return { resetData: null };
        }
    }

    alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => dispatch(setVisibleToast(false)), 4000);
    return rejectWithValue(message);
});

export const recoverPasswordBySMS = createAsyncThunk('recoverPasswordBySMS', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const usuarioNew = selectUsuario(state);
    const usuarioAttributes = { ...usuarioNew }
    const idUsuario = usuarioAttributes.idUsuario;
    let alert: AlertInterface;

    try {
        dispatch(setLoading(true));

        // Obtener el token del state
        const token = state.auth?.token || '';

        if (!token) {
            throw new Error('No se encontró el token de autenticación');
        }

        const body = { idUsuario };
        const { result, message, data } = await postRecoverPassword(body, token);

        dispatch(setLoading(false));

        if (result) {
            alert = {
                title: 'CONTRASEÑA ENVIADA',
                message: message || 'Se ha generado una nueva contraseña y se ha enviado por SMS al número de teléfono del alumno.',
                data: [],
                type: 'LimeGreen',
                time: Date.now()
            };
        }
        else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
        }

        dispatch(setDataToast(alert));
        dispatch(setVisibleToast(true));
        dispatch(setVisible(false));
        setTimeout(() => {
            dispatch(setVisibleToast(false));
        }, 4000);
        dispatch(fetchUsuario({}));

        if (result) {
            return { message, data };
        }
        return rejectWithValue(message);
    } catch (error: any) {
        dispatch(setLoading(false));
        const errorMessage = error?.message || 'Error al recuperar contraseña';
        alert = {
            title: 'ERROR',
            message: errorMessage,
            data: error?.data || null,
            type: 'Crimson',
            time: Date.now()
        };
        dispatch(setDataToast(alert));
        dispatch(setVisibleToast(true));
        dispatch(setVisible(false));
        setTimeout(() => {
            dispatch(setVisibleToast(false));
        }, 4000);
        return rejectWithValue(errorMessage);
    }
});


export const usuarioSlice = createSlice({
    name: 'usuario',
    initialState,
    reducers: {
        setUsuarioList: (state, action) => {
            state.usuarioList = action.payload;
        },
        setUsuario: (state, action) => {
            state.usuario = !action.payload ? initialState.usuario : action.payload;
        },
        setResetData: (state, action) => {
            state.resetData = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUsuario.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsuario.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.usuarioList = data ? data : [];

            })
            .addCase(fetchUsuario.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateUsuario.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateUsuario.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(modifyCreateUsuario.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(updateEstadoUsuario.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEstadoUsuario.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(updateEstadoUsuario.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(resetPassword.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.status = 'completed';
                state.resetData = action.payload?.resetData ?? null;
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(recoverPasswordBySMS.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(recoverPasswordBySMS.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(recoverPasswordBySMS.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }

})

export const selectUsuarioList = (state: RootState) => state.usuario.usuarioList;
export const selectUsuario = (state: RootState) => state.usuario.usuario;
export const selectResetData = (state: RootState) => state.usuario.resetData;

export const { setUsuarioList, setUsuario, setResetData } = usuarioSlice.actions;

export default usuarioSlice.reducer;